export default function PHP_dns_get_record() {
  return (
    <div>
      <h1>PHP_dns_get_record</h1>
    </div>
  );
}
